module.exports = __webpack_public_path__ + "img/L100.81214e4c.png";